var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0.75 0.75 22.5 22.5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 12L11 14L15 10M20 13C20 18 16.5 20.5 12.34 21.95C12.12 22.02 11.89 22.02 11.67 21.94C7.5 20.5 4 18 4 13V6C4 5.45 4.45 5 5 5C7 5 9.5 3.8 11.24 2.28C11.68 1.91 12.32 1.91 12.76 2.28C14.51 3.81 17 5 19 5C19.55 5 20 5.45 20 6V13Z",
    stroke: "var(--stroke-0, #31ADFF)",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield);
export default __webpack_public_path__ + "static/media/shield.4afb19feb06a4f8a75e1e4db18e22c6e.svg";
export { ForwardRef as ReactComponent };